// import { blackColor } from 'assets/jss/material-dashboard-pro-react';
import {
  container,
  title,
  main,
  grayColor,
  mainRaised,
} from 'assets/jss/material-kit-pro-react.js';
import footerStyle from 'assets/jss/material-kit-pro-react/views/componentsSections/footerStyle.js';

const presentationStyle = {
  ...footerStyle,
  main: {
    ...main,
    backgroundColor: 'rgb(34, 34, 34)',
    /*overflow: "hidden"*/
  },
  mainRaised,
  parallax: {
    height: '90vh',
    // Espacio bajo el menú fijo (~logo 80px + padding del AppBar) para que la fachada no quede recortada
    marginTop: '100px',
    overflow: 'hidden',
    // Llena el hero; un toque de “zoom out” con tamaño apenas mayor a cover vía posición
    backgroundSize: 'cover !important',
    backgroundPosition: 'center top !important',
    backgroundRepeat: 'no-repeat',
    backgroundColor: '#1a1a1a',
    // Desgaste / menos “IA”: viñeta + lavado
    '&:before': {
      content: '""',
      position: 'absolute',
      zIndex: 1,
      width: '100%',
      height: '100%',
      left: 0,
      top: 0,
      display: 'block',
      pointerEvents: 'none',
      background:
        'linear-gradient(to bottom, rgba(18,18,18,0.38) 0%, rgba(18,18,18,0.14) 40%, rgba(18,18,18,0.22) 70%, rgba(18,18,18,0.5) 100%),' +
        'radial-gradient(ellipse at center, transparent 50%, rgba(12,10,8,0.32) 100%)',
    },
    // Grano sutil
    '&:after': {
      content: '""',
      position: 'absolute',
      zIndex: 1,
      width: '100%',
      height: '100%',
      left: 0,
      top: 0,
      display: 'block',
      pointerEvents: 'none',
      opacity: 0.2,
      mixBlendMode: 'soft-light',
      backgroundColor: 'rgba(90, 78, 70, 0.22)',
      backgroundImage:
        'url("data:image/svg+xml,%3Csvg viewBox=\'0 0 256 256\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cfilter id=\'n\'%3E%3CfeTurbulence type=\'fractalNoise\' baseFrequency=\'0.85\' numOctaves=\'4\' stitchTiles=\'stitch\'/%3E%3C/filter%3E%3Crect width=\'100%25\' height=\'100%25\' filter=\'url(%23n)\' opacity=\'0.55\'/%3E%3C/svg%3E")',
      backgroundSize: '180px 180px',
    },
  },
  container: {
    ...container,
    position: 'relative',
    zIndex: 2,
  },
  title: {
    ...title,
    color: grayColor,
  },
};

export default presentationStyle;
